import React from "react";
import { BodyBuilder } from "../../../exports/Images";
import { convertThenFormat } from "../../common-data/Converts";

const AgentInfoMobile = ({ tableData, setModValues, cardName }) => {
  return (
    <div className="all-leads-log mt30">
      {tableData?.length > 0 &&
        tableData.map((row, index) => {
          return (
            <div className="log-card" key={index}>
              <div className="all-info">
                {cardName === "package_data" && (
                  <div className="log-card-top">
                    <h3 className="lead-name name-checkbox">
                      {row?.plan_name || "NA"}
                    </h3>
                  </div>
                )}

                <div
                  className="card-other-info"
                  style={{
                    padding:
                      cardName === "package_data" ? "0 20px 20px 20px" : "20px",
                  }}
                >
                  {cardName === "agent_info" && (
                    <>
                      <span className="value semi-bold">
                        <img
                          src={row?.profile || BodyBuilder}
                          alt={row?.name || "NA"}
                          className="image"
                          style={{
                            height: "100px",
                            width: "100px",
                            objectFit: "contain",
                          }}
                        />
                      </span>

                      <span className="value semi-bold">
                        agent name: <b>{row?.name || "NA"}</b>
                      </span>

                      <span className="value semi-bold">
                        agent mobile:
                        <b>{row?.mobile || "NA"}</b>
                      </span>

                      <span className="value semi-bold">
                        status: <b>{row?.status || "NA"}</b>
                      </span>
                    </>
                  )}

                  {cardName === "package_data" && (
                    <>
                      <span className="value semi-bold">
                        duration: <b>{row?.duration || "NA"}</b>
                      </span>

                      <span className="value semi-bold">
                        base price:{" "}
                        <b> ₹{convertThenFormat(row?.base_price || 0)}</b>
                      </span>

                      <span className="value semi-bold">
                        original price:{" "}
                        <b> ₹{convertThenFormat(row?.original_price || 0)}</b>
                      </span>

                      <span className="value semi-bold">
                        plan price:{" "}
                        <b> ₹{convertThenFormat(row?.plan_price || 0)}</b>
                      </span>

                      <span className="value semi-bold">
                        processing fee: <b>{row?.processing_fee || 0}</b>
                      </span>

                      <span className="value semi-bold">
                        first EMI: <b>{row?.first_emi_percentage || 0}%</b>
                      </span>

                      <span className="value semi-bold">
                        second EMI:
                        <b>
                          {" "}
                          {row?.second_emi_percentage || 0}% in{" "}
                          {row?.second_emi_duration || 0} days
                        </b>
                      </span>

                      <span className="value semi-bold">
                        third EMI:{" "}
                        <b>
                          {row?.third_emi_percentage || 0}% in{" "}
                          {row?.third_emi_duration || 0} days
                        </b>
                      </span>

                      <span className="value semi-bold">
                        description:
                        <b
                          dangerouslySetInnerHTML={{
                            __html: row?.description || "No Content Available",
                          }}
                        ></b>
                      </span>
                    </>
                  )}

                  {cardName === "partial_details" && (
                    <>
                      <span className="value semi-bold">
                        online amount:{" "}
                        <b> ₹{convertThenFormat(row?.online_amount || 0)}</b>
                      </span>

                      <span className="value semi-bold">
                        cash amount:{" "}
                        <b>₹{convertThenFormat(row?.cash_amount || 0)}</b>
                      </span>
                    </>
                  )}

                  {cardName === "plan_features" && (
                    <>
                      <span className="value semi-bold">
                        feature name: <b> {row?.feature_name || "NA"}</b>
                      </span>
                    </>
                  )}

                  {cardName === "price_details" && (
                    <>
                      <span className="value semi-bold">
                        plan type: <b> {row?.type || "NA"}</b>
                      </span>

                      <span className="value semi-bold">
                        plan price:{" "}
                        <b> ₹{convertThenFormat(row?.plan_price || 0)}</b>
                      </span>

                      <span className="value semi-bold">
                        status: <b> {row?.status || "NA"}</b>
                      </span>
                    </>
                  )}
                </div>

                {cardName === "package_data" && (
                  <div className="all-followuo-info-container">
                    <div className="all-btns lead-btn-axceed">
                      <div className="lead-log-box">
                        <button
                          className="lead-log view-lead"
                          onClick={() => {
                            row?.plan_features &&
                              setModValues((prevs) => ({
                                ...prevs,
                                isModOpen3: true,
                                cardName3: "plan_features",
                                rowData3: row?.plan_features || [],
                              }));
                          }}
                          style={{
                            opacity: row?.plan_features ? "1" : "0.5",
                            cursor: row?.plan_features
                              ? "pointer"
                              : "not-allowed",
                          }}
                          disabled={!row?.plan_features}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-view-list"
                            viewBox="0 0 16 16"
                          >
                            <path d="M3 4.5h10a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2m0 1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1zM1 2a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 2m0 12a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 14" />
                          </svg>
                        </button>

                        <span className="btn-label">plan features</span>
                      </div>

                      <div className="lead-log-box">
                        <button
                          className="lead-log view-lead"
                          onClick={() => {
                            row?.price_details &&
                              setModValues((prevs) => ({
                                ...prevs,
                                isModOpen3: true,
                                cardName3: "price_details",
                                rowData3: row?.price_details || [],
                              }));
                          }}
                          style={{
                            opacity: row?.price_details ? "1" : "0.5",
                            cursor: row?.price_details
                              ? "pointer"
                              : "not-allowed",
                          }}
                          disabled={!row?.price_details}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-view-list"
                            viewBox="0 0 16 16"
                          >
                            <path d="M3 4.5h10a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2m0 1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1zM1 2a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 2m0 12a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 14" />
                          </svg>
                        </button>

                        <span className="btn-label">price details</span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default AgentInfoMobile;
